import { useState } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  TouchableWithoutFeedback,
  StyleSheet,
} from "react-native";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import Arrow from "../../../../assets/icons/cards/down-arrow.svg";
import { regionOptions } from "./region-options";

const RegionDropdown = ({
  title: titleProp,
  showDropdownValues: showDropdownValuesProp,
  onDropdownClick,
  outsideClick,
  data: dataProp,
  onDropdownOptionClick,
}) => {
  const [internalShow, setInternalShow] = useState(false);
  const location = useLocation();
  const isMiddleEast = location.pathname.includes("middle-east");

  const defaultTitle = isMiddleEast ? "Middle East" : "India";
  const title = titleProp ?? defaultTitle;
  const data = dataProp ?? regionOptions;
  const isControlled = showDropdownValuesProp !== undefined;
  const showDropdownValues = isControlled
    ? showDropdownValuesProp
    : internalShow;

  const defaultHandleOptionClick = (value) => {
    if (!isControlled) {
      setInternalShow(false);
    }
    if (value === "middle-east") {
      window.location.href = "/middle-east";
    } else {
      window.location.href = "/";
    }
  };

  const handleHeaderPress = () => {
    if (isControlled) {
      onDropdownClick?.();
    } else {
      setInternalShow(!internalShow);
    }
  };

  const handleOptionPress = (value) => {
    if (onDropdownOptionClick) {
      onDropdownOptionClick(value);
    } else {
      defaultHandleOptionClick(value);
    }
  };

  return (
    <View style={styles.dropdownRoot}>
      {showDropdownValues && outsideClick ? (
        <TouchableWithoutFeedback onPress={outsideClick}>
          <View style={styles.outsideOverlay} />
        </TouchableWithoutFeedback>
      ) : null}
      <View
        style={[
          styles.dropdownContainer,
          showDropdownValues && styles.dropdownContainerOpen,
        ]}
      >
        <TouchableOpacity
          style={styles.dropdownHeader}
          onPress={handleHeaderPress}
          activeOpacity={0.8}
        >
          <Text style={styles.dropdownTitle}>{title} Edition</Text>
          <img
            src={Arrow}
            alt="arrow-down"
            style={{
              height: 16,
              width: 16,
              transition: "transform 0.2s ease-in-out",
              transform: showDropdownValues ? "rotate(180deg)" : "rotate(0deg)",
            }}
          />
        </TouchableOpacity>
        {showDropdownValues ? (
          <View style={styles.dropdownListContainer}>
            <View style={styles.dropdownList}>
              {data.map((item, index) => (
                <TouchableOpacity
                  key={index}
                  style={styles.dropdownItem}
                  onPress={() => handleOptionPress(item.value)}
                  activeOpacity={0.8}
                >
                  <Text style={styles.dropdownItemText}>{item.title}</Text>
                  {item.title === title ? (
                    <View style={styles.dropdownTick}>
                      <Text style={styles.dropdownTickText}>✓</Text>
                    </View>
                  ) : null}
                </TouchableOpacity>
              ))}
            </View>
          </View>
        ) : null}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  dropdownRoot: {
    position: "relative",
    overflow: "visible",
    zIndex: 1,
  },
  outsideOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 10049,
  },
  dropdownContainer: {
    position: "relative",
    zIndex: 10050,
    overflow: "visible",
  },
  dropdownContainerOpen: {
    zIndex: 10051,
    elevation: 10051,
  },
  dropdownHeader: {
    borderWidth: 1,
    borderColor: "#DDD",
    paddingVertical: 7,
    paddingHorizontal: 16,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    alignSelf: "flex-start",
  },
  dropdownTitle: {
    textTransform: "capitalize",
    color: "#292929",
    fontWeight: "700",
    fontSize: 14,
    fontFamily: "HaasGrotesk-Medium",
  },
  dropdownListContainer: {
    position: "absolute",
    top: 38,
    left: 0,
    zIndex: 10052,
    minWidth: "100%",
    overflow: "visible",
    elevation: 10052,
  },
  dropdownList: {
    backgroundColor: "#FFFFFF",
    borderWidth: 1,
    borderColor: "#DDD",
    paddingVertical: 12,
    shadowColor: "rgba(36, 27, 4, 0.1)",
    shadowOffset: { width: 0, height: 16 },
    shadowOpacity: 1,
    shadowRadius: 30,
    elevation: 10052,
  },
  dropdownItem: {
    paddingVertical: 8,
    paddingHorizontal: 12,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  dropdownItemText: {
    fontFamily: "HaasGrotesk-Medium",
    fontWeight: "700",
    fontSize: 14,
    textTransform: "capitalize",
    color: "#292929",
  },
  dropdownTick: {
    backgroundColor: "#1E1B4B",
    borderRadius: 50,
    paddingHorizontal: 4,
  },
  dropdownTickText: {
    color: "#FFFFFF",
    fontSize: 12,
  },
});

export default RegionDropdown;
